// AUTO-GENERATED by scripts/write-build-version.ts — do not edit.
// Empty string = version key disabled (current/pre-deploy-skew behaviour).
export const BUILD_VERSION = "8932eee8a09d5b2e6bdd281d50780ad7";
// The git sha, ALWAYS — BUILD_VERSION is a render-identity hash under
// CACHE_NAMESPACE_PIN=1 and cannot be compared against a commit.
export const BUILD_COMMIT = "7052bc914322";
